import { aasApiKeysQueryKeys } from './aas_api-keys-query-keys';
import {
  useCreate,
  useDelete,
  useEdit,
  usePaginated,
  useSingleFetch,
  useInfinite,
  useQuery,
} from '../react-query';
import { apiClient } from '../../apiHelper';
interface Filters {
  [key: string]: string | number;
}
interface DashboardStats {
  stats: {
    total_requests: number;
    active_keys: number;
    success_rate: number;
    total_images: number;
    avg_response_ms: number;
  };
  recent_requests: any[]; // Use the RequestHistoryItem type here
   all_requests_paginated?: { // This is the new field
    data: any[];
    total_count: number;
    page: number;
    items_per_page: number;
  }; 
  chart_data: any[]; // Use the RequestHistoryItem type here
}
export function useCreateAasApiKey() {
  const creatAasApiKeyFn = async (newAasApiKey) => {
    const response = await apiClient.post('aas/api_keys/create', newAasApiKey);
    return response.data;
  };
  return useCreate(
    creatAasApiKeyFn,
    aasApiKeysQueryKeys.all,
    'Error while creating new AAS API Key',
    'AAS API Key created successfully'
  );
}

export function useDashboardStats(config = {}) {
  const getDashboardStatsFn = async () => {
    const response = await apiClient.get('aas/request_history/dashboard/stats'); // Calling the new endpoint
    return response.data;
  };

  return useQuery(
    getDashboardStatsFn,
    ['dashboardStats'],
    {
      ...config,
    }
  );
}
export function usePaginatedDashboardStats( page: number,
  itemsPerPage: number,
  filters: Filters = {},
  config = {}) {
  const getPaginatedDashboardStatsFn =async (p = page,i=itemsPerPage,f = filters) => {
    console.log('Fetching paginated dashboard stats with filters:', p,i);
     const filtersQuery = Object.keys(f).map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(f[key])}`)
      .join('&');
    let url = `aas/request_history/dashboard/stats`;
    if( p && i) {
      url += `?page=${p}&items_per_page=${i}`;
    }
    const response = await apiClient.get(url);
      return response.data;
  };

  return usePaginated(
    getPaginatedDashboardStatsFn,
     ['dashboardStats', ...aasApiKeysQueryKeys.pagination(page).map(String)],
     page,
    itemsPerPage,
    config
  );
}
export function usePaginatedAasApiKeys( page: number,
  itemsPerPage: number,
  filters: Filters = {},
  config = {}) {
  const getPaginatedAasApiKeysFn = async (p = page,i=itemsPerPage,f = filters) => {
    console.log('Fetching paginated API keys with filters:', p,f);
    const filtersQuery = Object.keys(f).map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(f[key])}`)
      .join('&');
    const url = `aas/api_keys/?page=${p}&items_per_page=${i}${
      filtersQuery ? `&${filtersQuery}` : ''
    }`;
    const response = await apiClient.get(url);
      return response.data;
    
  };

  return usePaginated(
    getPaginatedAasApiKeysFn,
     ['aas_api_keys', ...aasApiKeysQueryKeys.pagination(page).map(String)],
    page,
    itemsPerPage,
    config
  );
}

export function useDeleteAasApiKey() {
  const deleteAasApiKeyFn = async (id) => {
    const response = await apiClient.delete(`aas/api_keys/delete/${id}`);
    return response;
  };

  return useDelete(
    deleteAasApiKeyFn,
    aasApiKeysQueryKeys.all,
    'Error while deleting AAS API Key',
    'AAS API Key deleted successfully'
  );
}

export function useEnableAasApiKey() {
  const enableAasApiKeyFn = async (id) => {
    const response = await apiClient.patch(`aas/api_keys/enable/${id}`);
    return response.data;
  };

  return useEdit(
    enableAasApiKeyFn,
    aasApiKeysQueryKeys.all,
    'Error while enabling AAS API Key',
    'AAS API Key enabled successfully',
  );
}

export function useDisableAasApiKey() {
  const disableAasApiKeyFn = async (id) => {
    const response = await apiClient.patch(`aas/api_keys/disable/${id}`);
    return response.data;
  };

  return useEdit(
    disableAasApiKeyFn,
    aasApiKeysQueryKeys.all,
    'Error while disabling AAS API Key',
    'AAS API Key disabled successfully'
  );
}
